// Component: SurveyErrorAlert
// Purpose: Inline error message display at the top of the survey page

import React from 'react';
import { X } from 'lucide-react';

export const SurveyErrorAlert = ({ 
  error, 
  currentStep, 
  campaign, 
  themes, 
  getTextStyle, 
  getSubtextStyle 
}) => {
  // Only show error message if we're not on the response page
  if (!error || currentStep === 'response') return null;

  return (
    <div className={`mb-6 rounded-lg border ${
      campaign?.theme && campaign.theme !== 'custom'
        ? `${themes[campaign.theme].border} bg-black/20` 
        : campaign?.theme === 'custom'
          ? 'border-white/20 bg-black/20'
          : 'border-red-200 bg-red-50'
    } p-4`}>
      <div className="flex items-start">
        <div className={`mr-3 flex-shrink-0 ${
          campaign?.theme && campaign.theme !== 'custom'
            ? themes[campaign.theme].text 
            : campaign?.theme === 'custom'
              ? 'text-white'
              : 'text-red-600'
        }`} style={campaign?.theme === 'custom' ? getTextStyle() : {}}>
          <X className="h-5 w-5" />
        </div>
        <div>
          <h3 className={`text-sm font-medium ${
            campaign?.theme && campaign.theme !== 'custom'
              ? themes[campaign.theme].text 
              : campaign?.theme === 'custom'
                ? 'text-white'
                : 'text-red-800'
          }`} style={campaign?.theme === 'custom' ? getTextStyle() : {}}>Error</h3>
          <div className={`mt-2 text-sm ${
            campaign?.theme && campaign.theme !== 'custom'
              ? themes[campaign.theme].subtext 
              : campaign?.theme === 'custom'
                ? 'text-white/80'
                : 'text-red-700'
          }`} style={campaign?.theme === 'custom' ? getSubtextStyle() : {}}>
            <p>{error}</p>
          </div>
        </div>
      </div>
    </div>
  );
};


